// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { SiteAccountModel } from './siteAccountModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class GetSiteAccountsResponseModel {
    'siteAccounts': Array<SiteAccountModel>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof GetSiteAccountsResponseModel>> = [
        {
            "name":     "siteAccounts",
            "baseName": "siteAccounts",
            "type":     "Array<SiteAccountModel>"
        },
    ];

    static getAttributeTypeMap() {
        return GetSiteAccountsResponseModel.attributeTypeMap;
    }
}
